// src/pages/auth/Subscribe.jsx
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appNavigation, urlMap } from '../../utils';
import Footer from '../components/Footer';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

class Subscribe extends Component {
  state = {
    email: '',
    submitting: false,
    error: null,
    notice: null,
    done: false,
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ error: null, notice: null });

    const email = this.state.email.trim();
    if (!EMAIL_RE.test(email)) {
      this.setState({ error: 'Please enter a valid email address.' });
      return;
    }

    this.setState({ submitting: true });

    try {
      // Relative path: proxied to the core service by nginx in both
      // localhost (docker) and production deployments.
      const res = await fetch(urlMap.subscribeNewsletter, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'spa-subscribe' }),
      });

      const payload = await res.json().catch(() => null);
      const apiMsg = (payload && (payload.message || payload.error)) || null;

      if (!res.ok) {
        if (res.status === 400) {
          this.setState({ error: 'Please enter a valid email address.', submitting: false });
          return;
        }
        if (res.status === 429) {
          this.setState({
            notice: { type: 'warning', text: 'Too many attempts. Please wait a moment and try again.' },
            submitting: false,
          });
          return;
        }
        if (res.status >= 500) {
          this.setState({ error: 'Server error. Please try again shortly.', submitting: false });
          return;
        }
        throw new Error(apiMsg || `Subscription failed (code ${res.status}).`);
      }

      this.setState({
        done: true,
        submitting: false,
        email: '',
        notice: { type: 'success', text: "You're subscribed. Thanks for joining!" },
      });
    } catch (err) {
      this.setState({
        error: err.message || 'Something went wrong. Please try again.',
        submitting: false,
      });
    }
  };

  render() {
    const { notice, error, submitting, done } = this.state;

    return (
      <div className="login-page">
        <div className="login-wrapper">
          <form className="login-form" onSubmit={this.handleSubmit}>
            {notice && (
              <div
                className={`notice ${notice.type}`}
                style={{
                  marginBottom: 12,
                  padding: '10px 12px',
                  borderRadius: 8,
                  background:
                    notice.type === 'success' ? '#e8f8ee' :
                    notice.type === 'warning' ? '#fff7e6' :
                    '#eef2ff',
                  color:
                    notice.type === 'success' ? '#146c2e' :
                    notice.type === 'warning' ? '#8a6d1d' :
                    '#3730a3',
                  border: '1px solid rgba(0,0,0,0.06)',
                }}
              >
                {notice.text}
              </div>
            )}

            <h2>Join our newsletter</h2>
            <p className="subtitle">
              Get product updates from the Storyclub team in Oslo.
            </p>

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleChange}
              disabled={submitting || done}
              required
            />

            <button type="submit" disabled={submitting || done}>
              {submitting ? 'Subscribing…' : done ? 'Subscribed' : 'Subscribe'}
            </button>

            {error && <p className="error-text">{error}</p>}

            <p className="footer-text">
              Already have an account? <Link to={appNavigation.login}>Login</Link>
            </p>
          </form>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Subscribe;
